import * as m from "@paraglide/messages"
import type { SupportedLocale as Lang } from "@site-types/site"
import "./styles.css"

export function Title({ locale }: { locale: Lang }) {
  return (
    <a
      className="menu-logo"
      href={`/${locale}`}
      aria-label="Menu Logo"
    >
      <img
        src="/playbrain-word-logo-white.svg"
        alt={(m.common_playbrain({}, { locale: locale }) ?? "PLAYBRAIN").toUpperCase()}
        width={208}
        height={40}
      />
    </a>
  )
}

export default Title
